import * as breakpoints from "../breakpoints";
import * as colors from "../constants/colors";
import { css, StyleSheet } from "aphrodite";
import Certificate from "./Certificate";
import { format } from "date-fns";
import { getCertificate, getCertificateById } from "../api/certificate";
import { rootUrl } from "../config";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";

const styles = StyleSheet.create({
	container: {
		position: "relative",
		backgroundColor: colors.white,
		zIndex: 2,
		[breakpoints.mobileOnly]: {
			width: "100vw",
			paddingLeft: 39,
			paddingRight: 36,
			paddingBottom: 0,
			overflow: "auto",
		},
		width: "100%",
		[breakpoints.tabletAndUp]: {
			maxWidth: 580,
		},
		maxHeight: "100vh",

		"@media (max-height: 750px)": {
			height: "100vh",
		},
	},
	fullScreenCover: {
		position: "fixed",
		height: "100vh",
		width: "100vw",
		backgroundColor: colors.transparentBlack,
		top: 0,
		left: 0,
		display: "flex",
		[breakpoints.tabletAndUp]: {
			justifyContent: "center",
			alignItems: "center",
		},
		zIndex: 2,
		"@media print": {
			backgroundColor: colors.white,
			alignItems: "flex-start",
			pageBreakAfter: "auto",
		},
		"@media (max-height: 750px)": {
			alignItems: "flex-start",
			overflow: "auto",
		},
	},
	xButton: {
		border: "none",
		position: "absolute",
		top: 13,
		right: 13,
		padding: 0,
		"@media print": {
			display: "none",
		},
	},
});

export default class CertificatModal extends PureComponent {
	static propTypes = {
		showing: PropTypes.bool,
		dismiss: PropTypes.func.isRequired,
		classId: PropTypes.string,
		certificateId: PropTypes.string,
		certificate: PropTypes.string,
		language: PropTypes.string.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			certificate: {},
		};
	}

	componentDidMount() {
		if (this.props.classId && !this.props.certificate) {
			this._getCertificate(this.props.classId);
		} else if (this.props.certificate) {
			this._getCertificateById(this.props.certificate);
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			(nextProps.classId && nextProps.classId !== this.props.classId) ||
			(nextProps.classId &&
				nextProps.showing &&
				!this.props.showing &&
				Object.keys(this.state.certificate).length === 0)
		) {
			this._getCertificate(nextProps.classId);
		} else if (
			nextProps.certificate &&
			(!this.state.certificate.id || this.state.certificate.id !== nextProps.certificate)
		) {
			this._getCertificateById(nextProps.certificate);
		}
	}

	_getCertificate = classId => {
		getCertificate(classId, this.props.language)
			.then(data => {
				this.setState({
					certificate: {
						...data.certificates[0],
						completionDate: format(data.certificates[0].completionDate, "M/D/YYYY"),
					},
				});
			})
			.catch(err => {
				console.log(`error getting certificate: ${err}`);
			});
	};

	_getCertificateById = certificateId => {
		getCertificateById(certificateId, this.props.language)
			.then(certificate =>
				this.setState({
					certificate,
				}),
			)
			.catch(() => {
				console.log("error getting certificate");
			});
	};

	_dontPropagate = e => {
		e.stopPropagation();
	};

	render() {
		if (!this.props.showing) {
			return null;
		} else if (Object.keys(this.state.certificate).length === 0) {
			return null;
		}
		let prompt = this.state.certificate.question;
		if (!prompt && this.state.certificate.class) {
			prompt = this.state.certificate.class.readerQuestion;
		}
		return (
			<div
				aria-hidden="true"
				onClick={this.props.dismiss}
				onKeyDown={this.props.dismiss}
				className={css(styles.fullScreenCover)}
			>
				<div
					aria-hidden="true"
					className={css(styles.container)}
					onClick={this._dontPropagate}
					onKeyDown={this._dontPropagate}
				>
					<Certificate
						completionDate={this.state.certificate.completionDate}
						certificateNumber={this.state.certificate.certificateNumber}
						courseTitle={
							this.state.certificate.class && this.state.certificate.class.name
								? this.state.certificate.class.name
								: undefined
						}
						courseImage={
							this.state.certificate.class && this.state.certificate.class.image
								? this.state.certificate.class.image
								: undefined
						}
						resolution={this.state.certificate.answer}
						resolutionPrompt={prompt}
						language={this.props.language}
					/>
					<button className={css(styles.xButton)} onClick={this.props.dismiss}>
						<img
							src={`${rootUrl}/images/x-black.png`}
							alt="x icon"
							srcSet={`${rootUrl}/images/x-black@2x.png 2x, ${rootUrl}/images/x-black@3x.png 3x`}
						/>
					</button>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/CertificateModal.js